import React from 'react';
import '../template-file-css/document-file-template.css';



export const BTCS_DiagnosticAssessment = ({
    itemsRef,
    showErrorFor,

}) => {

    
    return (
        <form id='BTCS_DiagnosticAssessment' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3><center>DIAGNOSTIC ASSESSMENT UPDATE FORM</center></h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Diagnostic Evaluation Update</span>
                            <span className='small'>(Check all that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbReasonForDiagnostic_1' name='cbReasonForDiagnostic_1' className='add-only' value='AnnualUpdate' /> Annual Update</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbReasonForDiagnostic_2' name='cbReasonForDiagnostic_2' className='add-only' value='ChangeCondition' /> Change in Condition</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbReasonForDiagnostic_3' name='cbReasonForDiagnostic_3' className='add-only' value='NewSymptoms' /> New Symptoms</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbReasonForDiagnostic_4' name='cbReasonForDiagnostic_4' className='add-only' value='AddingService' /> Adding a Service </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReasonForDiagnostic_5' name='cbReasonForDiagnostic_5' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_1' name='txtOther_1' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem (Any new life stressors? Tell me about your current symptoms, intensity, and duration):</span>
                    <textarea id='txtPresentingProblem_1' name='txtPresentingProblem_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Current Living Situation (Stable? Unstable? With whom do they live with?):</span>
                    <textarea id='txtCurrentLivingSituation_2' name='txtCurrentLivingSituation_2' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Support System (Where do you currently get your support from? Primary family, marital, friendship, peers?):</span>
                    <textarea id='txtSupportSystem_3' name='txtSupportSystem_3' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Pertinent Family History (Any changes since your last assessment in your families physical or mental health?):</span>
                    <textarea id='txtPertinentFamilyHistory_4' name='txtPertinentFamilyHistory_4' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Strengths (Positive characteristics and attributes, what are some things that you are good at?)</span>
                    <textarea id='txtStrengths_5' name='txtStrengths_5' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Limitations (Are there any health or mental health barriers preventing you from reaching your goals?)</span>
                    <textarea id='txtLimitations_6' name='txtLimitations_6' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Meaningful Activities (Tell me more about your interests, hobbies, religious and/or spirituality)</span>
                    <textarea id='txtMeaningfulActivities_7' name='txtMeaningfulActivities_7' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Education/Employment/Skills (Have you had any changes, started a new job, changed schools, graduated?) </span>
                    <textarea id='txtEducationEmployment_8' name='txtEducationEmployment_8' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Health (Date of your last medical visit? Any new concerns with your physical and/or mental health?)</span>
                    <textarea id='txtHealthDate_9' name='txtHealthDate_9' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Medications (Has there been any changes in medications or stopping of medications)</span>
                    <textarea id='txtMedications_10' name='txtMedications_10' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Alcohol/Drug use (Any concerns with your alcohol/drug use, Any AOD services since last assessment? Successful/unsuccessful?) </span>
                    <textarea id='txtAlcoholDrug_11' name='txtAlcoholDrug_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legal Issues (Probation, CCDCFS involvement?)</span>
                    <textarea id='txtLegalIssues_12' name='txtLegalIssues_12' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abuse/Neglect/Trauma/Exploitation (Has any other traumatic event occurred in the last year or is there anything from the past that you would like to address?)</span>
                    <textarea id='txtAbuseNeglect_13' name='txtAbuseNeglect_13' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Measurement Tools (Which tools are being used (Ohio Scales, GAD7, SPRINT, PHQ9?) Discuss the progress from the initial to the most recent changes with the client, any improvement in scores?) </span>
                    <textarea id='txtMeasurementTools_14' name='txtMeasurementTools_14' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Safety Screen (Are you experiencing any suicidal or homicidal ideations? Is there a crisis plan needed? Complete the CSSRS) </span>
                    <textarea id='txtSafetyScreen_15' name='txtSafetyScreen_15' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Pain Screen (Are you experiencing any pain? Compete Pain Screen refer out if needed.)</span>
                    <textarea id='txtPainScreen_16' name='txtPainScreen_16' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Mental Status Exam:</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>General Appearance:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbGeneralApperance_5' name='rbGeneralApperance' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'>
                            <input type='radio' id='rbGeneralApperance_6' name='rbGeneralApperance' className='add-only' value='Disheveled' /> Disheveled</td>
                        <td className='w-187'>
                            <input type='radio' id='rbGeneralApperance_7' name='rbGeneralApperance' className='add-only' value='Unkept' /> Unkept</td>
                        <td className='w-187'>
                            <input type='radio' id='rbGeneralApperance_8' name='rbGeneralApperance' className='add-only' value='Poor Hygienee' /> Poor Hygiene</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Build:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbBuild_9' name='rbBuild' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBuild_10' name='rbBuild' className='add-only' value='Thin' /> Thin</td>
                        <td className='w-187'>
                            <input type='radio' id='rbBuild_11' name='rbBuild' className='add-only' value='Obese' /> Obese</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Eye Contact:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbEyeContact_12' name='rbEyeContact' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'>
                            <input type='radio' id='rbEyeContact_13' name='rbEyeContact' className='add-only' value='Avoidant' /> Avoidant</td>
                        <td className='w-187'>
                            <input type='radio' id='rbEyeContact_14' name='rbEyeContact' className='add-only' value='Intense' /> Intense</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Motor Activity:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_15' name='rbMotorActivity' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_16' name='rbMotorActivity' className='add-only' value='Agitation' /> Agitation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_17' name='rbMotorActivity' className='add-only' value='DecreaseAmount' /> Decrease Amount </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_18' name='rbMotorActivity' className='add-only' value='IncreasedAmount' /> Increased Amount</td>

                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_19' name='rbMotorActivity' className='add-only' value='PeculiarPosturing' /> Peculiar Posturing</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_20' name='rbMotorActivity' className='add-only' value='RepetitiveActions' /> Repetitive Actions</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_21' name='rbMotorActivity' className='add-only' value='Tics' /> Tics</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMotorActivity_22' name='rbMotorActivity' className='add-only' value='Tremors' /> Tremors</td>

                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMotorActivity_23' name='rbMotorActivity' className='add-only' value='UnusualGait' /> Unusual Gait</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMotorActivity_24' name='rbMotorActivity' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_2' name='txtOther_2' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_25' name='rbJudgment' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_26' name='rbJudgment' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_27' name='rbJudgment' className='add-only' value='Poor' /> Poor</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Memory:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_28' name='rbMemory' className='add-only' value='Intact' /> Intact</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_29' name='rbMemory' className='add-only' value='Confabulation' /> Confabulation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_30' name='rbMemory' className='add-only' value='PoorDistant' /> Poor Distant </td>
                        <td className='w-187'>
                            <input type='radio' id='rbMemory_31' name='rbMemory' className='add-only' value='PoorRecent' /> Poor Recent</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMemory_32' name='rbMemory' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_3' name='txtOther_3' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Concentration/Attention:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbConcentrationAttention_33' name='rbConcentrationAttention' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbConcentrationAttention_34' name='rbConcentrationAttention' className='add-only' value='Distractible' /> Distractible</td>
                        <td className='w-187'>
                            <input type='radio' id='rbConcentrationAttention_35' name='rbConcentrationAttention' className='add-only' value='Variable' /> Variable</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbConcentrationAttention_36' name='rbConcentrationAttention' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_4' name='txtOther_4' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Dress:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDress_37' name='rbDress' className='add-only' value='AppropriateAttire' /> Appropriate Attire</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDress_38' name='rbDress' className='add-only' value='Eccentric' /> Eccentric</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDress_39' name='rbDress' className='add-only' value='Seductive' /> Seductive</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDress_40' name='rbDress' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_5' name='txtOther_5' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_41' name='rbInsight' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_42' name='rbInsight' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_43' name='rbInsight' className='add-only' value='Poor' /> Poor</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Cognitive Ability:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbCongnitiveAbility_44' name='rbCongnitiveAbility' className='add-only' value='Intact' /> Intact</td>
                        <td className='w-187'>
                            <input type='radio' id='rbCongnitiveAbility_45' name='rbCongnitiveAbility' className='add-only' value='Impaired' /> Impaired</td>
                        <td className='w-187'>
                            <input type='radio' id='rbCongnitiveAbility_46' name='rbCongnitiveAbility' className='add-only' value='Retarded' /> Retarded</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_47' name='rbSpeech' className='add-only' value='Clear' /> Clear</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_48' name='rbSpeech' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_49' name='rbSpeech' className='add-only' value='Slowed' /> Slowed</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSpeech_50' name='rbSpeech' className='add-only' value='Stuttering' /> Stuttering</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSpeech_51' name='rbSpeech' className='add-only' value='Pressured' /> Pressured</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sensorium/Orientation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbSensoriumOrientation_52' name='rbSensoriumOrientation' className='add-only' value='Orientatedx3' /> Orientatedx3</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSensoriumOrientation_53' name='rbSensoriumOrientation' className='add-only' value='Orientatedx2' /> Orientatedx2</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSensoriumOrientation_54' name='rbSensoriumOrientation' className='add-only' value='Oreintatedx1' /> Oreintatedx1</td>
                        <td className='w-187'>
                            <input type='radio' id='rbSensoriumOrientation_55' name='rbSensoriumOrientation' className='add-only' value='Oreintatedx0' /> Oreintatedx0</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Flow of Thought:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_56' name='rbFlowThought' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_57' name='rbFlowThought' className='add-only' value='Blocking' /> Blocking</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_58' name='rbFlowThought' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_59' name='rbFlowThought' className='add-only' value='FlightIdeas' /> Flight of Ideas</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_60' name='rbFlowThought' className='add-only' value='LooseAssociations' /> Loose Associations</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_61' name='rbFlowThought' className='add-only' value='Perseveration' /> Perseveration</td>
                        <td className='w-187'>
                            <input type='radio' id='rbFlowThought_62' name='rbFlowThought' className='add-only' value='Tangential' /> Tangential</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect/Mood:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_63' name='rbAffectMood' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_64' name='rbAffectMood' className='add-only' value='Anxious' /> Anxious</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_65' name='rbAffectMood' className='add-only' value='Blunted' /> Blunted</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_66' name='rbAffectMood' className='add-only' value='Constricted' /> Constricted</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_67' name='rbAffectMood' className='add-only' value='Depressed' /> Depressed</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_68' name='rbAffectMood' className='add-only' value='Flat' /> Flat</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_69' name='rbAffectMood' className='add-only' value='Euthymic' /> Euthymic</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_70' name='rbAffectMood' className='add-only' value='Euphoric' /> Euphoric</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_71' name='rbAffectMood' className='add-only' value='Irritable' /> Irritable</td>
                        <td className='w-187'>
                            <input type='radio' id='rbAffectMood_72' name='rbAffectMood' className='add-only' value='Perseveration' /> Labile </td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAffectMood_73' name='rbAffectMood' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_6' name='txtOther_6' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Daily Patterns:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_74' name='rbDailyPatterns' className='add-only' value='NormalSleep' /> Normal Sleep </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_75' name='rbDailyPatterns' className='add-only' value='PoorSleepQuality' /> Poor Sleep Quality</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_76' name='rbDailyPatterns' className='add-only' value='DecreasedSleep' /> Decreased Sleep Quality</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_77' name='rbDailyPatterns' className='add-only' value='IncreaseSleep' /> Increase Sleep</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_78' name='rbDailyPatterns' className='add-only' value='Nightmares' /> Nightmares </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_79' name='rbDailyPatterns' className='add-only' value='Fatigue' /> Fatigue</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_80' name='rbDailyPatterns' className='add-only' value='IncreasedSexDrive' /> Increased Sex Drive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_81' name='rbDailyPatterns' className='add-only' value='DecreasedSexDrive' /> Decreased Sex Drive</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_82' name='rbDailyPatterns' className='add-only' value='SocialWithdrawal' /> Social Withdrawal </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_83' name='rbDailyPatterns' className='add-only' value='DecreasedAppetite' /> Decreased Appetite</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_84' name='rbDailyPatterns' className='add-only' value='NormalAppetite' /> Normal Appetite </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_85' name='rbDailyPatterns' className='add-only' value='IncreaseAppetite' /> Increase Appetite </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_86' name='rbDailyPatterns' className='add-only' value='Binging' /> Binging</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_87' name='rbDailyPatterns' className='add-only' value='Purging' />  Purging</td>
                        <td className='w-187'>
                            <input type='radio' id='rbDailyPatterns_88' name='rbDailyPatterns' className='add-only' value='DecreasedWorkPerformance' /> Decreased Work Performance </td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Content of Thought:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_89' name='rbContentOfThought' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_90' name='rbContentOfThought' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_91' name='rbContentOfThought' className='add-only' value='ExcessiveReligiosity' /> Excessive Religiosity</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_92' name='rbContentOfThought' className='add-only' value='GuiltFocused' /> Guilt Focused</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_93' name='rbContentOfThought' className='add-only' value='Hallucinations' /> Hallucinations</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_94' name='rbContentOfThought' className='add-only' value='Hopelessness' /> Hopelessness</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_95' name='rbContentOfThought' className='add-only' value='ImpairedReality' /> Impaired Reality</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_96' name='rbContentOfThought' className='add-only' value='Obsession' /> Obsession</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_97' name='rbContentOfThought' className='add-only' value='Paranoia' /> Paranoia</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_98' name='rbContentOfThought' className='add-only' value='SexualPreoccupation' /> Sexual Preoccupation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_99' name='rbContentOfThought' className='add-only' value='SomaticPreoccupations' /> Somatic Preoccupations</td>
                        <td className='w-187'>
                            <input type='radio' id='rbContentOfThought_100' name='rbContentOfThought' className='add-only' value='Worthlessness' /> Worthlessness</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbContentOfThought_101' name='rbContentOfThought' className='add-only' value='Other' /> Other &nbsp;
                            <input type='text' id='txtOther_7' name='txtOther_7' className='add-only w-350 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Interview Behavior:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_102' name='rbInterviewBehavior' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_103' name='rbInterviewBehavior' className='add-only' value='Aggressive' /> Aggressive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_104' name='rbInterviewBehavior' className='add-only' value='Angry' /> Angry</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_105' name='rbInterviewBehavior' className='add-only' value='Apathetic' /> Apathetic</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_106' name='rbInterviewBehavior' className='add-only' value='Argumentative' /> Argumentative</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_107' name='rbInterviewBehavior' className='add-only' value='Callous' /> Callous</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_108' name='rbInterviewBehavior' className='add-only' value='Childish/Silly' /> Childish/Silly</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_109' name='rbInterviewBehavior' className='add-only' value='Cooperative' /> Cooperative</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_110' name='rbInterviewBehavior' className='add-only' value='Demanding' /> Demanding</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_111' name='rbInterviewBehavior' className='add-only' value='Dramatic' /> Dramatic</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_112' name='rbInterviewBehavior' className='add-only' value='Evasive' /> Evasive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_113' name='rbInterviewBehavior' className='add-only' value='Hostile' /> Hostile</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_114' name='rbInterviewBehavior' className='add-only' value='Impulsive' /> Impulsive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_115' name='rbInterviewBehavior' className='add-only' value='Irritable' /> Irritable</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_116' name='rbInterviewBehavior' className='add-only' value='Manipulative' /> Manipulative</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_117' name='rbInterviewBehavior' className='add-only' value='Naive' /> Naive</td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_118' name='rbInterviewBehavior' className='add-only' value='Negativistic' /> Negativistic</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_119' name='rbInterviewBehavior' className='add-only' value='Passive' /> Passive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_120' name='rbInterviewBehavior' className='add-only' value='Sensitive' /> Sensitive</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInterviewBehavior_121' name='rbInterviewBehavior' className='add-only' value='Uncooperative' /> Uncooperative</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbInterviewBehavior_122' name='rbInterviewBehavior' className='add-only' value='Withdrawn' /> Withdrawn</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <h3>Justification for Diagnosis</h3>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Write the criteria that the client meets for the diagnosis. Does the client still meet the
                        criteria for current diagnosis? If not, is the diagnosis being changed? Is there an additional
                        diagnosis being added? Please explain:</span>
                    <textarea id='txtWriteTheCriteriaThattheClient_17' name='txtWriteTheCriteriaThattheClient_17' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Check Primary</span></td>
                        <td className='w-100'>
                            <span className='eleHeader'>Code</span></td>
                        <td className='w-550'>
                            <span className='eleHeader'>Diagnosis Label</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckPrimary_123' name='cbCheckPrimary_123' className='add-only' value='1' /> </td>
                        <td className='w-100'>
                            <input type='text' id='txtCode_8' name='txtCode_8' className='add-only' /></td>
                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisLabel_9' name='txtDiagnosisLabel_9' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckPrimary_124' name='cbCheckPrimary_124' className='add-only' value='2' /> </td>
                        <td className='w-100'>
                            <input type='text' id='txtCode_9' name='txtCode_9' className='add-only' /></td>
                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisLabel_10' name='txtDiagnosisLabel_10' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckPrimary_125' name='cbCheckPrimary_125' className='add-only' value='3' /> </td>
                        <td className='w-100'>
                            <input type='text' id='txtCode_10' name='txtCode_10' className='add-only' /></td>
                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisLabel_11' name='txtDiagnosisLabel_11' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckPrimary_126' name='cbCheckPrimary_126' className='add-only' value='4' /> </td>
                        <td className='w-100'>
                            <input type='text' id='txtCode_11' name='txtCode_11' className='add-only' /></td>
                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisLabel_12' name='txtDiagnosisLabel_12' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckPrimary_127' name='cbCheckPrimary_127' className='add-only' value='5' /> </td>
                        <td className='w-100'>
                            <input type='text' id='txtCode_12' name='txtCode_12' className='add-only' /></td>
                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisLabel_13' name='txtDiagnosisLabel_13' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbCheckPrimary_128' name='cbCheckPrimary_128' className='add-only' value='6' /> </td>
                        <td className='w-100'>
                            <input type='text' id='txtCode_13' name='txtCode_13' className='add-only' /></td>
                        <td className='w-550'>
                            <input type='text' id='txtDiagnosisLabel_14' name='txtDiagnosisLabel_14' className='add-only' /></td>
                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Provider Signature/Credentials </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Supervisor Signature/Credentials </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}  
